import { createSlice } from '@reduxjs/toolkit';

export const googleLoginSlice = createSlice({
  name: 'googleLogin',
  initialState: {
    value: false,
  },
  reducers: {
    updateGoogleLogin: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { updateGoogleLogin } = googleLoginSlice.actions;

export const selectGoogleLogin = (state) => state.googleLogin.value;

export default googleLoginSlice.reducer;